import { useState } from 'react'
import { Collapse, Stack, Typography } from '@mui/material'
import { thoughtStepIcon } from '@/features/chat/phase1/thoughtStepIcon'
import ThoughtRail from './ThoughtRail'
import styles from './thoughtchain.module.scss'

export default function ThoughtStep({
  category,
  title,
  streaming = false,
  running = false,
  completed = false,
  showConnector = true,
  defaultExpanded,
  children,
}) {
  const [expanded, setExpanded] = useState(
    defaultExpanded ?? (streaming || running),
  )
  const Icon = thoughtStepIcon(category, { completed })
  const toggle = () => setExpanded((value) => !value)
  return (
    <Stack direction="row" className={styles.step} alignItems="stretch">
      <ThoughtRail
        icon={Icon}
        expanded={expanded}
        onToggle={toggle}
        showConnector={showConnector}
      />
      <Stack className={styles.stepBody}>
        <Typography
          component="button"
          type="button"
          className={styles.stepTitle}
          onClick={toggle}
        >
          {title}
        </Typography>
        <Collapse in={expanded}>
          <Stack className={styles.stepContent}>{children}</Stack>
        </Collapse>
      </Stack>
    </Stack>
  )
}
